module.exports = {
  APILOCALURL: "http://localhost:5126/api/",
  APISERVERURL: "https://b2cclienttravel.azurewebsites.net/api/",
  APIACTIVEURL: "https://b2cclienttravel.azurewebsites.net/api/",
  DEFAULTCOMPANYID: "EFD32BD2-6639-42ED-9B1A-7E262DA1BE07",
  DEFAULTCURRENCY: "INR",
  LOGIN: "auth/admin-login",
  REGISTER: "auth/register",
  LOGOUT: "auth/logout",
  REFRESH: "auth/refresh",
  SENDRESETLINK: "auth/sendresetlink",
  RESETPASSWORD: "auth/resetpassword",
  SENDCONFIRMATIONLINK: "auth/sendconfirmationlink",
  REGISTERCOMPANY: "auth/registercompany",
  MANUALPASSWORD:"user/manualpassword",
  CHANGEAGENTPASSWORD:"user/changeagentpassword",

  CREATECOMPANYWALLET: "companywallet",
  UPDATECOMPANYWALLET: "companywallet",
  DELETECOMPANYWALLET: "companywallet",
  
  CREATETEMPLATE: "template",
  GETALLTEMPLATES: "template/all",
  GETTEMPLATEPREVIEWDATA: "template/preview-data",

  SAASREGISTER: "company/saasregister",
  SAASACTIVATE: "company/UpdateTaxInformation",
  VERIFYCOMPANY: "auth/verifyemail",
  SUPPLIERREGISTER: "company/supplierregister",
  SUPPLIERACTIVATE: "company/UpdateSupplierInformation",
  CREATECOMPANYBYSUPERADMIN: "company/createcompanybysuperadmin",
  UPDATECOMPANYBYSUPERADMIN: "company/updatebysuperadmin",

  CREATESUBSCRIPTION: "Subscription/create",
  CONFIRMSUBSCRIPTION: "Subscription/confirm",

  AISUPPLIERGENRATE: "aiitinerary/generate",
  CREATEAIWEBPACKAGE: "aiitinerary/create-website-package",
  GENRATEANDSAVE: "aiitinerary/generate-and-save",
  AISUPPLIERGENRATEANDSAVE: "aiitinerary/supplier-generate-and-save",
  SEARCHFLIGHTALTERNATIVES: "flight/search-alternatives",

  GETCREDITHISTORY: "credithistory/company",
  GETPRICINGPLANS: "connects/pricing",
  RECHARGECONNECTS: "connects/recharge",

  GETUSERSBYCOMPANY: "user/getbycompany",
  GETUSERSBYBRANCH: "user/getbybranch",
  GETSTAFFBYCOMPANY: "User/getstaffbycompany",
  CREATEUSER: "user",
  UPDATEUSER: "user",
  DELETEUSER: "user",
  GETUSERPROFILE: "user/getprofile",
  CHANGEPASSWORD: "user/changepassword",

  GETALLCOMPANIES: "company/getall",
  GETCOMPANIES: "company/get",
  GETCOMPANYBYID: "company/getbyid",
  GETCOMPANYBYUSER: "company/getbyuser",
  GETCOMPANYAGENTS: "company/agents",
  GETCOMPANYSUPPLIERS: "company/suppliers",
  GETALLAGENTBYCOMPANY: "company/getallagents",
  CREATECOMPANY: "company",
  UPDATECOMPANY: "company",
  DELETECOMPANY: "company",
  CREATEB2BCOMPANY: "company/b2bcreate",
  UPDATEB2BCOMPANY: "company/updateagent",
  UPDATECOMPANYSTATUS: "company/updatestatus",
  UPDATEWHATSAPPNUMBER: "company/updatewhatsappnumber",
  UPDATECOMPANYCHATBOT: "company/updatechatbot",
  CONNECTWHATSSDK: "whatsapp/start-signup",
  WHATSAPPFINISH: "whatsapp/finish-signup",
  WHATSAPPVERIFY: "whatsapp/verify-code",

  GETALLBRANCHES: "branch/getall",
  GETBRANCHES: "branch/get",
  GETBRANCHBYID: "branch/getbyid",
  GETBRANCHBYUSER: "branch/getbyuser",
  GETBRANCHBYCOMPANY: "branch/getbycompany",
  CREATEBRANCH: "branch",
  UPDATEBRANCH: "branch",
  DELETEBRANCH: "branch",

  GETCOMPANYMENUBYCOMPANY: "companymenu/getbycompany",
  CREATECOMPANYMENU: "companymenu",
  UPDATECOMPANYMENU: "companymenu",
  DELETECOMPANYMENU: "companymenu",

  GETCURRENCYBYCOMPANY: "currency/getbycompany",
  CREATECURRENCY: "currency",
  UPDATECURRENCY: "currency",
  DELETECURRENCY: "currency",

  GETALLSUPPLIERS: "supplier/getall",
  GETSUPPLIERS: "supplier/get",
  GETSUPPLIERBYCOMPANY: "supplier/getbycompany",
  GETALLSUPPLIERSBYCOMPANY: "supplier/getallsuppliersbycompany",
  CREATESUPPLIER: "supplier",
  UPDATESUPPLIER: "supplier",
  DELETESUPPLIER: "supplier",
  GETAPIKEYS: "Supplier/GetAPIKeys",
  GETSUPPLIERKEYSFORCLIENTCOMPANY: "supplier/get-suppliers",

  GETALLLEADSTATUS: "leadstatus/getall",
  GETLEADSTATUS: "leadstatus/get",
  GETLEADSTATUSBYCOMPANY: "leadstatus/getbycompany",
  GETLEADSTATUSBYID: "leadstatus/getbyid",
  CREATELEADSTATUS: "leadstatus",
  UPDATELEADSTATUS: "leadstatus",
  DELETELEADSTATUS: "leadstatus",
  GETLEADSFORCALENDAR: "lead/getbycompanyforcalendar",
  GETLEADDASHBOARD: "lead/getleaddashboard",

  GETALLLEAD: "lead/getall",
  GETLEAD: "lead/get",
  GETLEADBYCOMPANY: "lead/getbycompany",
  GETLEADBYUSER: "lead/getbyuser",
  GETLEADBYID: "lead/getbyid",
  CREATELEAD: "lead",

  UPDATELEAD: "lead",
  DELETELEAD: "lead",
  SENDPDF: "packageshare/sendpackageaspdf",
  SENDBULKPDF: "packageshare/sendbulkpackageaspdf",

  GETALLMEETING: "meeting/getall",
  GETMEETING: "meeting/get",
  GETMEETINGBYLEAD: "meeting/getbylead",
  GETMEETINGBYID: "meeting/getbyid",
  CREATEMEETING: "meeting",
  UPDATEMEETING: "meeting",
  DELETEMEETING: "meeting",
  GETUSERCHAT: "WhatsAppChat/userchat",
  FULLLEADREPORT: "meeting/full-lead-report",

  GETALLSOURCE: "source/getall",
  GETSOURCE: "source/get",
  GETSOURCEBYID: "source/getbyid",
  CREATESOURCE: "source",
  UPDATESOURCE: "source",
  DELETESOURCE: "source",

  GETPAYMENTGATEWAYBYCOMPANY: "paymentgateway/getbycompany",
  CREATEPAYMENTGATEWAY: "paymentgateway",
  UPDATEPAYMENTGATEWAY: "paymentgateway",
  DELETEPAYMENTGATEWAY: "paymentgateway",
  MAKEPAYMENT: "payment/process",

  GETPROMOCODEBYCOMPANY: "promocode/getbycompany",
  CREATEPROMOCODE: "promocode",
  UPDATEPROMOCODE: "promocode",
  DELETEPROMOCODE: "promocode",

  SEARCHFLIGHTS: "flight/search",
  REVIEWHFLIGHT: "flight/review",
  BOOKFLIGHT: "flight/book",
  GETUSERFLIGHTBOOKINGS: "flight/getbyuser",
  GETCOMPANYFLIGHTBOOKINGS: "flight/getbycompany",
  GETPARENTCOMPANYFLIGHTBOOKINGS: "flight/getbyparentcompany",
  GETFLIGHTBOOKINGDETAILS: "flight/getbyid",
  CONFIRMHOLDFLIGHTBOOKING: "flight/Confirm-Hold",
  UPDATEFLIGHTBOOKING: "flight/updatebooking",

  SEARCHHOTEL: "hotel/search",
  GETHOTELROOMS: "hotel/rooms",
  HOTELREVIEW: "hotel/review",
  BOOKHOTEL: "hotel/book",
  GETUSERHOTELBOOKINGS: "hotel/getbyuser",
  GETHOTELBOOKINGDETAILS: "hotel/getbyid",
  GETCOMPANYHOTELBOOKINGS: "hotel/getbycompany",
  GETPARENTCOMPANYHOTELBOOKINGS: "hotel/getbyparentcompany",
  GETGSTREPORT: "hotel/gstreport",

  GETALLDESTINATIONTYPES: "destinationtype/getall",
  GETDESTINATIONTYPES: "destinationtype",
  CREATEDESTINATIONTYPE: "destinationtype",
  UPDATEDESTINATIONTYPE: "destinationtype",
  GETDESTINATIONTYPEBYID: "destinationtype/getbyid",
  DELETEDESTIONTYPE: "destinationtype",

  GETALLDESTINATIONS: "destination/getall",
  GETDESTINATION: "destination/get",
  GETDESTINATIONBYID: "destination/getbyid",
  GETALLDESTINATIONBYCOMPNAYID: "destination/getallbycompany",
  GETDESTINATIONBYCOMAPANYID: "destination/getbycompany",
  CREATEDESTINATION: "destination",
  UPDATEDESTINATION: "destination",
  DELETEDESTINATION: "destination",
  GETDESTIONBYTYPE: "destination/gettypebycompany",

  GETALLTRAVELTYPES: "traveltype/getall",
  GETTRAVELTYPE: "traveltype",
  CREATETRAVELTYPE: "traveltype",
  UPDATETRAVELTYPE: "traveltype",
  GETTRAVELTYPEBYID: "traveltype/getbyid",
  DELETETRAVELTYPE: "traveltype",

  GETALLPACKAGES: "package/getall",
  GETPACKAGE: "package/get",
  GETPACKAGEBYID: "package/getbyid",
  GETPACKAGEBYCOMAPANYID: "package/getbycompany",
  CREATEPACKAGE: "package",
  UPDATEPACKAGE: "package",
  DELETEPACKAGE: "package",
  GETPACKAGEDETAILS: "package/getpackagedetails",
  CLONEPACKAGE: "package/clone",
  GETPACKAGESBYDESTINATION: "package/getbydestination",
  GETPACKAGESBYSEARCH: "package/getbysearch",
  GETPACKAGESBYUMRAHSEARCH: "package/getbysearchumrah",
  UPDATEPACKAGESTATUS: "package/updatestatus",
  UPDATETOGGLE: "package/togglewebsite",
  GETWEBSITEPACKAGES: "package/getwebsitepackagesbycompany",

  GETALLPACKAGEFLIGHT: "pacakgeflightbooking/getall",
  GETPACKAGEFLIGHT: "packageflightbooking/get",
  GETPACKAGEFLIGHTBYID: "pacakgeflightbooking/getbyid",
  GETFLIGHTBYPACKAGEID: "packageflightbooking/getflightbypackageid",
  CREATEPACKAGEFLIGHT: "packageflightbooking",
  UPDATEPACKAGEFLIGHT: "packageflightbooking",
  DELETEPACKAGEFLIGHT: "packageflightbooking",

  GETALLPACKAGEHOTEL: "pacakgebooking/getall",
  GETPACKAGEHOTEL: "packagehotelbooking/get",
  GETPACKAGEHOTELBYID: "pacakgehotelbooking/getbyid",
  GETHOTELBYPACKAGEID: "packagehotelbooking/gethotelbypackageid",
  CREATEPACKAGEHOTEL: "packagehotelbooking",
  UPDATEPACKAGEHOTEL: "packagehotelbooking",
  DELETEPACKAGEHOTEL: "packagehotelbooking",

  GETALLPACKAGESIGHT: "pacakgesightseeing/getall",
  GETPACKAGESIGHT: "packagesightseeing/get",
  GETPACKAGESIGHTBYID: "pacakgesightseeing/getbyid",
  GETSIGHTBYPACKAGEID: "packagesightseeing/getsightseeingbypackageid",
  CREATEPACKAGESIGHT: "packagesightseeing",
  UPDATEPACKAGESIGHT: "packagesightseeing",
  DELETEPACKAGESIGHT: "packagesightseeing",

  GETALLPACKAGEINCLUDES: "packageinclude/getall",
  GETPACKAGEINCLUDE: "packageinclude/get",
  GETALLPACKAGEINCLUDEBYID: "packageinclude/getbyid",
  GETINCLUDEBYPACKAGEID: "packageinclude/getincludebypackageid",
  CREATEPACKAGEINCLUDE: "packageinclude",
  UPDATEPACKAGEINCLUDE: "packageinclude",
  DELETEPACKAGEINCLUDE: "packageinclude",

  GETALLPACKAGEEXCLUDES: "packageexclude/getall",
  GETPACKAGEEXCLUDE: "packageexclude/get",
  GETALLPACKAGEEXCLUDEBYID: "packageexclude/getbyid",
  GETEXCLUDEBYPACKAGEID: "packageexclude/getexcludebypackageid",
  CREATEPACKAGEEXCLUDE: "packageexclude",
  UPDATEPACKAGEEXCLUDE: "packageexclude",
  DELETEPACKAGEEXCLUDE: "packageexclude",

  GETALLTERMS: "packagetermsandcondition/getall",
  GETPACKAGETERMS: "packagetermsandcondition/get",
  GETALLPACKAGETERMSBYID: "packagetermsandcondition/getbyid",
  GETTERMSBYPACKAGEID: "packagetermsandcondition/gettermsbypackageid",
  CREATEPACKAGETERMS: "packagetermsandcondition",
  UPDATEPACKAGETERMS: "packagetermsandcondition",
  DELETEPACKAGETERMS: "packagetermsandcondition",

  GETALLTRANSFERS: "pacakgetransfer/getall",
  GETPACKAGETRANSFER: "pacakgetransfer/get",
  GETALLPACKAGETRANSFERBYID: "pacakgetransfer/getbyid",
  GETTRANSFERBYPACKAGEID: "pacakgetransfer/gettransferbypackageid",
  CREATEPACKAGETRANSFER: "pacakgetransfer",
  UPDATEPACKAGETRANSFER: "pacakgetransfer",
  DELETEPACKAGETRANSFER: "pacakgetransfer",

  GETALLITINERAIES: "packageitinerary/getall",
  GETPACKAGEITINERARY: "packageitinerary/get",
  GETALLPACKAGEITINERARYBYID: "packageitinerary/getbyid",
  GETITINERARYBYPACKAGEID: "packageitinerary/getitinerarybypackageid",
  CREATEPACKAGEITINERARY: "packageitinerary",
  UPDATEPACKAGEITINERARY: "packageitinerary",
  DELETEPACKAGEITINERARY: "packageitinerary",

  GETALLCUSTOMERS: "customer/getall",
  GETCUSTOMERS: "customer/get",
  GETCUSTOMERBYID: "customer/getbyid",
  GETCUSTOMERBYCOMAPANYID: "customer/getbycompany",
  CREATECUSTOMER: "customer",
  UPDATECUSTOMER: "customer",
  DELETECUSTOMER: "customer",
  GETALLCUSTOMERSBYCOMPANYID: "customer/getallbycompanyid",

  MARKETING: "marketing/sendcampaign",

  SIGHTSEEINGPRODUCTS: "sightseeing/getproducts",
  SIGHTSEEINGPRODUCT: "sightseeing/getproduct",
  SIGHTSEEINGBOOK: "sightseeing/book",
  GETSIGHTSEEINGBOOKINGDETAILS: "sightseeing/getbyid",
  GETPARENTCOMPANYSIGHTSEEINGBOOKINGS: "sightseeing/getbyparentcompany",

  GETALLORIGIN: "fromorigin/getall",
  GETORIGIN: "fromorigin/get",
  GETORIGINBYID: "fromorigin/getbyid",
  GETALLORIGINBYCOMPANYID: "fromorigin/getallbycompany",
  GETORIGINBYCOMPANYID: "fromorigin/getbycompany",
  CREATEORIGIN: "fromorigin",
  UPDATEORIGIN: "fromorigin",
  DELETEORIGIN: "fromorigin",

  GETALLPACKAGEDATE: "packagedate/getall",
  GETPACKAGEDATE: "packagedate/get",
  GETPACKAGEDATEBYID: "packagedate/getbyid",
  GETALLPACKAGEDATEBYCOMPANY: "packagedate/getallbycompany",
  GETPACKAGEDATEBYCOMPANYID: "packagedate/getbycompany",
  CREATEPACKAGEDATE: "packagedate",
  UPDATEPACKAGEDATE: "packagedate",
  DELETEPACKAGEDATE: "packagedate",
  GETDATESBYTYPE: "packagedate/getdatesbytypeandcompany",

  GETALLPACKAGEENQUIRY: "packageenquiry/getall",
  GETPACKAGEENQUIRYBYID: "packageenquiry/getbyid",
  GETPACKAGEENQUIRYBYCOMPANYID: "packageenquiry/getbycompany",
  CREATEPACKAGEENQUIRY: "packageenquiry",
  UPDATEPACKAGEENQUIRY: "packageenquiry",
  DELETEPACKAGEENQUIRY: "packageenquiry",
  GETENQUIRYBYTYPE: "packageenquiry/getbytypeandcompany",

  GETLANDINGBYCOMPANY: "landingpage/getbyCompany",
  UPDATELANDINGPAGE: "landingpage",

  CREATEBOOKINGREQUEST: "groupbooking",
  GETAGENTBOOKING: "groupbooking/getbyagent",
  GETADMINBOOKING: "groupbooking/getbyadmin",
  DELETEBOOKINGREQUEST: "groupbooking",
  UPDATEBOOKINGREQUEST: "groupbooking/updatestatus",
  GETBOOKINGBYID: "groupbooking",

  GETDASHBOARD: "dashboard",

  GETAPPLICANTSBYPACKAGE: "packageapplicant/getbypackage",
  GETAPPLICANTBYID: "packageapplicant/getbyId",
  CREATEAPPLICANT: "packageapplicant",
  UPDATEAPPLICANT: "packageapplicant",
  DELETEAPPLICANT: "packageapplicant",
  DELETEAPPLICANTDOCUMENT: "packageapplicant/document",

  GETALLPROMOTIONS: "promotion/getall",
  GETPROMOTIONS: "promotion/get",
  GETPROMOTIONBYID: "promotion/getbyid",
  GETPROMOTIONBYUSER: "promotion/getbyuserid",
  CREATEPROMOTION: "promotion",
  UPDATEPROMOTION: "promotion",
  DELETEPROMOTION: "promotion",
  SENDPROMOTIONWHATSAPP: "promotion/send",

  GETVISAREQUESTSBYCOMPANY: "visarequest/getbycompany",
  GETVISAREQUESTBYID: "visarequest/getbyid",
  GETVISAREQUESTREPORTBYCOMPANY: "visarequest/getvisareportbycompany",
  GETVISASUPPLIERREPORT: "visarequest/getvisasupplierreport",
  SENDVISATOSUPPLIER: "visarequest/send",
  CREATEVISAREQUEST: "visarequest",
  UPDATEVISASTATUS: "visaRequest/UpdateStatus",
  UPDATEVISAMARKUP: "visaRequest/updatepricing",
  DELETEVISAREQUEST: "visaRequest",

  GETVISAAPPLICANTSBYREQUEST: "visaapplicant",
  GETVISAREQUESTSBYSUPPLIER: "visaapplicant/supplier",
  CREATEVISAAPPLICANT: "visaapplicant",
  UPDATEVISAAPPLICANT: "visaapplicant",
  DELETEVISAAPPLICANT: "visaapplicant",

  DELETEVISAAPPLICANTDOCUMENT: "visaapplicant/delete-document",

  // Other endpoints
  GETSUPPLIERVISAPRICES: "suppliervisaprice/get",
  GETSUPPLIERVISAPRICESBYSUPPLIERID: "suppliervisaprice/getbysupplier",
  GETSUPPLIERVISAPRICESBYVISAID: "suppliervisaprice/getbyvisa",
  CREATEUPPLIERVISAPRICE: "suppliervisaprice",
  UPDATESUPPLIERVISAPRICE: "suppliervisaprice",
  DELETESUPPLIERVISAPRICE: "suppliervisaprice",

  SEARCHFBUSES: "bus/search",
  GETBUSSEATS: "bus/seats",
  GETBUSBOOKINGBYID: "bus/getbooking",
  BOOKBUSSEATS: "bus/bookbusticket",
  CONFIRMBUSBOOKING: "/bus/confirmbooking",
  GETBUSBOOKINGS: "bus/getbookings",
  GETUSERBUSBOOKINGS: "bus/getbyuser",

  GETAllBANKACCOUNTS: "companybankaccount/getallbycompany",
  GETBANKSBYCOMPANYID: "companybankaccount/getbycompany",
  CREATECOMPANYBANK: "companybankaccount",
  UPDATECOMPANYBANK: "companybankaccount",
  DELETECOMPANYBANK: "companybankaccount",

   GETFLGIHTREPORTBYCOMPANYID: "flight/getbycompanyreport",
    GETTOPUPHISTORYBYCOMPANYID: "companywallet/getbycompany",
};
